"use client";
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import j, { useRef as L, useState as _, useEffect as z } from "react";
import { classNames as m } from "../../utilities/index.js";
import A from "../Label/index.js";
import "./index.css.js";
const B = ({ labelText: d, id: a, hideLabel: u, children: b, className: f, groupClass: p, assistiveText: o, required: h, error: s, errorText: x, helpText: t, tooltipContent: l, tooltipPosition: g = "bottom", ...$ }) => {
  var w, y;
  const n = ((y = (w = j.Children) == null ? void 0 : w.toArray(b)) == null ? void 0 : y.length) === 1, r = L(null), [v, N] = _(!1), C = m({
    "sash-FormGroup sash-FormGroupSelect relative mb-4": !0,
    "after:content": n,
    [p]: p
  }), E = m({
    "sash-Select font-semibold text-black w-full appearance-none text-base focus:outline-none": !0,
    "bg-white py-3 pl-3 pr-10 border min-h-[54px] disabled:border-gray-60 disabled:bg-gray-3 focus:border-blue focus:ring-1": !n,
    "pointer-events-none bg-transparent": n,
    "border-black": !s,
    "border-red": s,
    [f]: f
  }), F = m({
    "sash-InputTooltip absolute bg-white p-2 border border-black z-2 text-caption shadow-md right-0 max-w-[40ch] w-fit": !0,
    "bottom-full": g === "top",
    "top-full": g === "bottom"
  });
  z(() => {
    if (!(!l || !t))
      return document.addEventListener("click", k), () => document.removeEventListener("click", k);
  }, [l, t]);
  const G = (c) => {
    c.preventDefault(), N(!v);
  }, k = (c) => {
    var S;
    r != null && r.current && !((S = r.current) != null && S.contains(c.target)) && N(!1);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      ref: r,
      className: C,
      children: [
        (d || t) && /* @__PURE__ */ i("div", { className: `relative flex items-center ${!o && (!u || t) ? "mb-1" : ""}`, children: [
          /* @__PURE__ */ e(
            A,
            {
              htmlFor: a,
              className: `flex-1 ${h ? "text-required" : ""}`,
              hide: u,
              error: s,
              children: d
            }
          ),
          t && /* @__PURE__ */ e(
            "button",
            {
              className: "ml-auto flex-none text-xs leading-tight text-blue hover:underline",
              onClick: G,
              children: t
            }
          ),
          v && l && /* @__PURE__ */ e("div", { className: F, children: l })
        ] }),
        o && /* @__PURE__ */ e("p", { className: `mb-1 mt-px text-xs leading-tight ${s ? "text-red" : "text-gray-60"}`, children: o }),
        /* @__PURE__ */ e("div", { className: `sash-SelectWrapper relative ${n ? "after:content-none" : ""}`, children: /* @__PURE__ */ e(
          "select",
          {
            id: a,
            name: a,
            className: E,
            required: h,
            ...$,
            children: b
          }
        ) }),
        s && x && /* @__PURE__ */ i(
          "p",
          {
            "aria-describedby": a,
            className: "flex items-center text-xs text-red",
            children: [
              /* @__PURE__ */ e("span", { className: "material-symbols-sharp mr-1 text-base", children: "warning" }),
              x
            ]
          }
        )
      ]
    }
  );
}, q = B;
export {
  q as default
};
